<template>
  <div>
    <receipts-details
      receipt-type="Income"
    />
    <receipts-details
      receipt-type="Expense"
    />
  </div>
</template>

<script>
import ReceiptsDetails from '@/components/finance/receipt-details.vue'

export default {
  name: 'Receipts',
  components: {
    ReceiptsDetails
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .income {
    color: green;
  }
  .expense {
    color: red;
  }
</style>
